import { render } from "./mentalHealthPolicy.vue?vue&type=template&id=508c5f14&scoped=true"
import script from "./mentalHealthPolicy.vue?vue&type=script&lang=js"
export * from "./mentalHealthPolicy.vue?vue&type=script&lang=js"

import "./mentalHealthPolicy.vue?vue&type=style&index=0&id=508c5f14&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508c5f14"]])

export default __exports__